__turbopack_context__.v({
  "accent": "ui-module__ZYehbG__accent",
  "block": "ui-module__ZYehbG__block",
  "browser": "ui-module__ZYehbG__browser",
  "browserBar": "ui-module__ZYehbG__browserBar",
  "browserDot": "ui-module__ZYehbG__browserDot",
  "browserUrl": "ui-module__ZYehbG__browserUrl",
  "btn": "ui-module__ZYehbG__btn",
  "darkBand": "ui-module__ZYehbG__darkBand",
  "delta": "ui-module__ZYehbG__delta",
  "eyebrow": "ui-module__ZYehbG__eyebrow",
  "eyebrowDark": "ui-module__ZYehbG__eyebrowDark",
  "faq": "ui-module__ZYehbG__faq",
  "faqAnswer": "ui-module__ZYehbG__faqAnswer",
  "faqButton": "ui-module__ZYehbG__faqButton",
  "faqIcon": "ui-module__ZYehbG__faqIcon",
  "faqItem": "ui-module__ZYehbG__faqItem",
  "faqOpen": "ui-module__ZYehbG__faqOpen",
  "floatCard": "ui-module__ZYehbG__floatCard",
  "floatLabel": "ui-module__ZYehbG__floatLabel",
  "floatValue": "ui-module__ZYehbG__floatValue",
  "ghost": "ui-module__ZYehbG__ghost",
  "gridOverlay": "ui-module__ZYehbG__gridOverlay",
  "heading": "ui-module__ZYehbG__heading",
  "headingStart": "ui-module__ZYehbG__headingStart",
  "iconChip": "ui-module__ZYehbG__iconChip",
  "iconChipSm": "ui-module__ZYehbG__iconChipSm",
  "laptop": "ui-module__ZYehbG__laptop",
  "laptopBase": "ui-module__ZYehbG__laptopBase",
  "laptopBody": "ui-module__ZYehbG__laptopBody",
  "laptopScreen": "ui-module__ZYehbG__laptopScreen",
  "lead": "ui-module__ZYehbG__lead",
  "leadDark": "ui-module__ZYehbG__leadDark",
  "lg": "ui-module__ZYehbG__lg",
  "light": "ui-module__ZYehbG__light",
  "outline": "ui-module__ZYehbG__outline",
  "panel": "ui-module__ZYehbG__panel",
  "phone": "ui-module__ZYehbG__phone",
  "phoneScreen": "ui-module__ZYehbG__phoneScreen",
  "primary": "ui-module__ZYehbG__primary",
  "scaler": "ui-module__ZYehbG__scaler",
  "scalerInner": "ui-module__ZYehbG__scalerInner",
  "title": "ui-module__ZYehbG__title",
  "titleDark": "ui-module__ZYehbG__titleDark",
});
